export default __webpack_public_path__ + "JDZhengHei-01-Regular.cd64095c.ttf";